<template>
  <b-modal
    id="not-verified-modal"
    title="CitSci Account Email Verification"
    size="lg"
    centered
    ref="notVerifiedModal"
  >
    <div class="container">
      <div class="row justify-content-lg-center">
        <div class="col-auto">
          <b-card id="activate-loader" bg-variant="light">
            <b-form-group>
              <div>
                <b>Thank you for registering to be a part of CitSci!</b>
                <br><br>
                To prevent spam and bots, some site features are restricted to accounts with a verified email.<br>
                Please, verify your CitSci account email to access these features.<br><br>
                <b>Follow these steps: </b><br>
                1. Click the 'Resend Verification Email' button below.<br>
                2. You should receive a new verification email.<br>
                3. Click the link in the verification email that was sent to you.<br><br>
              </div>
            </b-form-group>
            <div v-if="emailSent">
              <u><b>The CitSci account verification email was successfully sent!</b></u>
              <div class="mt-2">
                Be sure to check the spam folder
                and add <strong>noreply@citsci.org</strong> to your safe sender's list.<br>
                <i class="small">Note: CitSci account email verification links expire after 30 days.</i>
              </div>
              <div class="mt-2 text-muted small" v-if="cooldownSeconds > 0">
                You may resend the verification email again in {{ cooldownSeconds }}
                second{{ cooldownSeconds !== 1 ? 's' : '' }}.
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="row justify-content-between d-flex">
        <div class="col-auto">
          <div class="btn btn-secondary" @click="$refs.notVerifiedModal.hide()">{{
              emailSent ? 'Close' : 'Cancel'
            }}
          </div>
          <b-button
            type="submit"
            class="ResendEmail"
            v-b-tooltip title="Send a CitSci Account Verification Email"
            @click="onClickResendEmail"
            variant="primary"
            :disabled="emailSent && cooldownRemaining > 0"
          >Resend Verification Email
          </b-button>
        </div>
      </div>

    </template>
  </b-modal>

</template>

<script>

import {mapActions, mapGetters} from 'vuex'

export default {

  data() {
    return {
      cooldownRemaining: 0,
      cooldownTimer: null,
    }
  },

  created() {
    this.startCooldown()
  },

  beforeDestroy() {
    // if (this.cooldownTimer) {
    //   clearInterval(this.cooldownTimer)
    // }
  },

  computed: {
    cooldownSeconds() {
      return Math.ceil(this.cooldownRemaining)
    },
    ...mapGetters({
      hasSession: 'user/profile/hasSession',
      isVerified: 'user/profile/isVerified',
      userId: 'user/profile/id',
      userEmail: 'user/profile/email',
      isLoading: 'user/activate/isLoadingEmail',
      emailSent: 'user/activate/emailSent',
      error: 'user/activate/error',
    }),
  },

  methods: {
    ...mapActions({
      resendEmail: 'user/activate/resendEmail'
    }),

    onClickResendEmail() {
      if (this.hasSession && !this.isVerified) {
        this.resendEmail({"id": this.userId, "email": this.userEmail})
      }
    },

    startCooldown() {
      this.cooldownRemaining = 900 // 15 minutes in seconds
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer)
      }
      this.cooldownTimer = setInterval(() => {
        this.cooldownRemaining--
        if (this.cooldownRemaining <= 0) {
          this.cooldownRemaining = 0
          clearInterval(this.cooldownTimer)
          this.cooldownTimer = null
        }
      }, 1000)
    },
  },

  watch: {
    emailSent(sent) {
      if (sent) {
        this.startCooldown()
      }
    },
  }

}
</script>
